import { type WithId } from "@client/types";
import classnames from "classnames";
import * as React from "react";

import "./style.less";

export type ID = string | number;

export type GridItem = WithId<ID> & {
  isSelected?: boolean;
};

export interface GridProps<TItemProps extends {} = {}, TItem extends GridItem = GridItem> {
  className?: string;
  columns: number;
  columnWidth?: string;
  itemGap?: string | number;
  selectedItemId?: ID;
  onItemClick?: (item: TItem) => void;

  itemProps?: TItemProps;
  items: Array<TItem | ID>;
  ItemComponent: React.ComponentType<TItemProps & TItem>;
}

class GridInner<TItemProps extends {}, TItem extends GridItem> extends React.PureComponent<
  GridProps<TItemProps, TItem>
> {
  public render() {
    const props = this.props;
    const { ItemComponent } = props;
    return (
      <div
        className={classnames("wsc_grid", props.className, { selectable: props.selectedItemId || props.onItemClick })}
        style={{
          gridGap: props.itemGap,
          gridTemplateColumns: `repeat(${props.columns}, minmax(0, ${props.columnWidth || "1fr"}))`
        }}
      >
        {props.items.map((mixed, index) => {
          const item = (typeof mixed === "object" ? mixed : ({ id: mixed } as any)) as any;
          return (
            <div
              key={item.id}
              className={classnames("wsc_grid_item", {
                selected: props.selectedItemId === item.id,
                "with-admin-border-color": props.selectedItemId === item.id
              })}
              onClick={this._getOnItemClick(item.id)}
            >
              <ItemComponent isSelected={props.selectedItemId === item.id} {...(props.itemProps || {})} {...item} />
            </div>
          );
        })}
      </div>
    );
  }

  private _getOnItemClick(id: ID) {
    if (!this.props.onItemClick) return undefined;

    return () =>
      this.props.onItemClick!(
        (this.props.items.find((it) => (typeof it === "object" ? it.id === id : it === id)) as TItem) || null
      );
  }
}

export { GridInner };
const Grid = React.memo(GridInner);
export default Grid;
